import React from 'react';
import { cn } from '../../lib/utils';
import iyzicoLogo from '../../assets/payment/iyzico-ile-ode-color.svg';
import visaMastercardLogo from '../../assets/payment/visa-mastercard-color.png';

const variantMap = {
  footer: {
    wrapper: 'mt-3 flex flex-wrap items-center gap-3',
    logoHeight: 'h-7',
  },
  checkout: {
    wrapper: 'mt-3 flex flex-wrap items-center gap-2',
    logoHeight: 'h-8',
  },
  confirmation: {
    wrapper: 'mt-3 flex flex-wrap items-center gap-2',
    logoHeight: 'h-8',
  },
};

const PaymentLogos = ({ variant = 'footer', showIyzicoLabel = false }) => {
  const styles = variantMap[variant] || variantMap.footer;
  return (
    <div className={styles.wrapper} aria-label="Desteklenen ödeme sağlayıcıları">
      <img
        src={visaMastercardLogo}
        alt="Visa ve MasterCard"
        className={cn(styles.logoHeight, 'w-auto object-contain')}
        loading="lazy"
        decoding="async"
      />
      <img
        src={iyzicoLogo}
        alt="iyzico ile öde"
        className={cn(styles.logoHeight, 'w-auto object-contain')}
        loading="lazy"
        decoding="async"
      />
      {showIyzicoLabel && <span className="text-xs text-gray-600">iyzico ile öde</span>}
    </div>
  );
};

export default PaymentLogos;
